<div class="options-container">

  <mat-form-field class="w-p-100" floatPlaceholder="always" floatLabel="always" appearance="outline">
    <mat-label>{{dialogField.title}}</mat-label>
    <input matInput placeholder="Input" style="display: none"
           particleAnalytics
           analyticsCategory="choice-filter-modal-item-editor"
           analyticsAction="entity-scope-input">
    <ul>
      <li *ngFor="let option of this.options; let i= index"
          class="flex flex-row justify-between items-center">
        <div class="container flex flex-row justify-start items-center full-grow-no-shrink-no-basis"
             *ngIf="!optionIsEditingState[option.id]">
          <div class="icons flex flex-col">
            <i class="fa-solid fa-caret-up" (click)="moveOption(option, i, 'up')"></i>
            <i class="fa-solid fa-caret-down" (click)="moveOption(option, i, 'down')"></i>
          </div>
          <label class="full-grow-no-shrink-no-basis" title="{{option.text}}"
                 (click)="startEditItem(option)">{{option.text}}</label>
          <div class="right-sidebar-icons">
            <mat-form-field appearance="outline" class="flex-0-0-100" *ngIf="optionIdIsEditingState[i]">
              <mat-label>Edit Option Id</mat-label>
              <input matInput attr.data-cy="Edit Option Id" [(ngModel)]="option.id" name="i"
                     [placeholder]="'Edit'" [ngModelOptions]="{standalone: true}">
            </mat-form-field>

            <mat-form-field appearance="outline" class="flex-0-0-100" *ngIf="translationIsEditingState[i]">
              <mat-label>Edit Translation</mat-label>
              <input matInput attr.data-cy="Edit Translation" [(ngModel)]="option.metaData.TranslatedText" name="translation"
                     [placeholder]="'Translation'" [ngModelOptions]="{standalone: true}">
            </mat-form-field>

            <button mat-icon-button class="icon-dropdown-button"
                    *ngIf="translationIsEditingState[i]"
                    (click)="editTranslationDone(i)">
              <i class="fa-regular fa-check"></i>
            </button>
            <button mat-icon-button class="icon-dropdown-button"
                    *ngIf="!translationIsEditingState[i]"
                    (click)="editTranslation(i, option)">
              <i class="fa-solid fa-language"></i>
            </button>

            <button mat-icon-button class="icon-dropdown-button" *ngIf="optionIdIsEditingState[i]"
                    (click)="editOptionIdDone(i)">
              <i class="fa-regular fa-check"></i>
            </button>
            <button mat-icon-button class="icon-dropdown-button" *ngIf="!optionIdIsEditingState[i]"
                    (click)="editOptionId(i)">
              <i class="fa-solid fa-money-check-pen"></i>
            </button>
            <button mat-icon-button class="icon-dropdown-button">
              <i class="fa-solid fa-star"></i>
            </button>
            <button mat-icon-button class="icon-dropdown-button" [disabled]="!option.isCustom"
                    (click)="removeOption(option)">
              <i class="fa-solid fa-trash"></i>
            </button>

          </div>
        </div>
        <div *ngIf="optionIsEditingState[option.id]" class="flex flex-row justify-start items-center">
          <particle-inplace-input
            [text]="option.text"
            placeHolder="Title"
            (valueChanged)="onSaveOption($event)"
            (cancelled)='resetOptionEditing()'
          ></particle-inplace-input>
        </div>
      </li>
      <li *ngIf="isOptionEditing" class="flex flex-row justify-between items-center">
        <particle-inplace-input
          [text]="exitingText"
          placeHolder="Title"
          (valueChanged)="onSaveOption($event)"
          (cancelled)='resetOptionEditing()'
        ></particle-inplace-input>
      </li>
    </ul>
  </mat-form-field>


  <ul class="buttons">
    <li>
      <button *ngIf="!isOptionEditing  && !isAddOptionDisabled" mat-button class="common-button "
              (click)="addOption()">
        {{addButtonTitle}}
      </button>
    </li>
  </ul>
</div>
